"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.onCodeMirrorChange = exports.createCodeMirror = exports.updateCodeMirrorTags = void 0;
const common_utils_1 = require("@zapier/common-utils");
const getTagPositions_1 = __importDefault(require("../../../PrettyText/utils/getTagPositions"));
const PreviewPill_1 = __importStar(require("../../../PreviewPill"));
const lodash_1 = require("lodash");
const react_dom_1 = __importDefault(require("react-dom"));
function createTagNode({ choiceGroups, onClickTag, pos, }) {
    const node = document.createElement('span');
    const previewPillProps = PreviewPill_1.getPreviewPillProps(choiceGroups, pos.tag);
    if (choiceGroups.length > 0 && lodash_1.get(choiceGroups[0], 'items', []).length > 0) {
        react_dom_1.default.render(common_utils_1.isolateComponent(PreviewPill_1.default, Object.assign({}, previewPillProps, { onClick: onClickTag })), node);
        return node;
    }
    return undefined;
}
function updateCodeMirrorTags({ choiceGroups, codeMirror, onClickTag, }) {
    if (!codeMirror) {
        return;
    }
    const positions = getTagPositions_1.default(codeMirror.getValue());
    const ops = () => {
        positions.forEach(pos => {
            const node = createTagNode({ choiceGroups, onClickTag, pos });
            codeMirror.markText({ line: pos.line, ch: pos.start }, { line: pos.line, ch: pos.stop }, { replacedWith: node, handleMouseEvents: true });
        });
    };
    codeMirror.operation(ops);
}
exports.updateCodeMirrorTags = updateCodeMirrorTags;
function createCodeMirror({ codeMirrorConstructor, node, placeholder, value, }) {
    const options = {
        extraKeys: {
            Tab: false,
            'Shift-Tab': false,
        },
        lineWrapping: true,
        mode: null,
        placeholder: String(placeholder),
        readOnly: false,
        tabIndex: '0',
        value,
    };
    return codeMirrorConstructor(node, options);
}
exports.createCodeMirror = createCodeMirror;
function onCodeMirrorChangeImmediate({ choiceGroups, codeMirror, onChange, onClickTag, }) {
    if (codeMirror) {
        onChange(codeMirror.getValue());
        updateCodeMirrorTags({ choiceGroups, codeMirror, onClickTag });
    }
}
exports.onCodeMirrorChange = lodash_1.debounce(onCodeMirrorChangeImmediate, 200);
